export default __webpack_public_path__ + "5722ec1de85793d4aa2842e9c812e285.svg";